import ActionType from '../actions/ActionType'
import * as routes from '../components/routes'
import { list } from './data'
import { DATA_API_URL } from '../utils/AllURLs'

export const toggleAdvancedSearchCheckbox = payload => dispatch =>
  dispatch({ type: ActionType.View.TOGGLE_ADVANCED_SEARCH_CHECKBOX, payload })

export const toggleDialog = payload => dispatch =>
  dispatch({ type: ActionType.View.TOGGLE_DIALOG, payload })

export const toggleDrawer = () => ({
  type: ActionType.View.TOGGLE_DRAWER,
})

export const closeDrawer = () => ({
  type: ActionType.View.CLOSE_DRAWER,
})

export const openDrawer = () => ({
  type: ActionType.View.OPEN_DRAWER,
})

export const toggleDeleteDialog =
  (payload = null) =>
  dispatch =>
    dispatch({
      type: ActionType.View.TOGGLE_DELETE_DIALOG,
      payload,
    })

export const changeSortBy = (listType, sortBy) => dispatch =>
  dispatch({
    type: ActionType.View.CHANGE_SORT_BY,
    payload: { listType, sortBy },
  })

export const changeSortOrder = (listType, order) => dispatch =>
  dispatch({
    type: ActionType.View.CHANGE_SORT_ORDER,
    payload: { listType, order },
  })

export const selectUserAssignment = payload => dispatch =>
  dispatch({ type: ActionType.View.SELECT_USER_ASSIGNMENT, payload })

export const search = payload => dispatch =>
  dispatch({ type: ActionType.View.SEARCH, payload })

export const toggleMultiExpansionPanel = payload => dispatch =>
  dispatch({ type: ActionType.View.TOGGLE_MULTI_EXPANSION_PANEL, payload })

export const setExpansionPanels = payload => dispatch =>
  dispatch({ type: ActionType.View.SET_EXPANSION_PANELS, payload })

export const updateExpansionPanels = payload => dispatch =>
  dispatch({
    type: ActionType.View.UPDATE_EXPANSION_PANELS,
    payload,
  })

export const closeError = () => dispatch =>
  dispatch({ type: ActionType.View.CLOSE_ERROR })

export const closeSnackbar = () => dispatch =>
  dispatch({ type: ActionType.View.CLOSE_SNACKBAR })

export const openSnackbar = payload => dispatch =>
  dispatch({ type: ActionType.View.OPEN_SNACKBAR, payload })

export const stepperIncrease = stepperType => dispatch =>
  dispatch({ type: ActionType.View.STEPPER_INCREASE, stepperType })

export const stepperDecrease = stepperType => dispatch =>
  dispatch({ type: ActionType.View.STEPPER_DECREASE, stepperType })

export const stepperGoTo = (payload, stepperType) => dispatch =>
  dispatch({ type: ActionType.View.STEPPER_GO_TO, payload, stepperType })

export const toggleErrorsDialog = payload => dispatch =>
  dispatch({ type: ActionType.View.TOGGLE_ERRORS_DIALOG, payload })

export const updateCount = payload => dispatch =>
  dispatch({ type: ActionType.View.UPDATE_COUNT, payload })

export const openProfileDialog = payload => dispatch =>
  dispatch({ type: ActionType.View.OPEN_PROFILE_DIALOG, payload })

export const openImageDialog = payload => dispatch =>
  dispatch({ type: ActionType.View.OPEN_IMAGE_DIALOG, payload })

export const openDeletePersonalDataDialog = payload => dispatch =>
  dispatch({ type: ActionType.View.OPEN_DELETE_PERSONAL_DATA_DIALOG, payload })

export const openLoadingDialog = payload => dispatch =>
  dispatch({ type: ActionType.View.OPEN_LOADING_DIALOG, payload })

export const forceListUpdate = () => dispatch =>
  dispatch({
    type: 'View.FORCE_LIST_UPDATE',
  })

export const refreshList = endpoint => (dispatch, getState) => {
  const route = Object.values(routes).find(r => r.endpoint === endpoint)

  if (!route) {
    console.error(`No route found for endpoint: ${endpoint}`)
    return
  }

  // Get the current pathname from the Redux store
  const currentPath = getState().router.location.pathname

  // Check if we're already on the page corresponding to this endpoint
  if (currentPath !== route.path) {
    console.log(`Not refreshing list for ${endpoint} as we're not on that page`)
    return
  }

  const refreshPromises = []

  if (route.listFn) {
    Object.values(route.listFn).forEach(fn => {
      refreshPromises.push(dispatch(fn()))
    })
  } else {
    refreshPromises.push(
      dispatch(list(endpoint)),
      dispatch(
        list(
          'userpin',
          null,
          `${DATA_API_URL}/userpin/username-entity?secondary_id=${endpoint}`,
        ),
      ),
    )
  }

  return Promise.all(refreshPromises)
    .then(() => {
      dispatch(forceListUpdate())
    })
    .catch(error => {
      console.error('Error refreshing list:', error)
    })
}